import Ajax from './Ajax'

const PaymentToken = {
  getPaymentTokens: () => {
    return Ajax.get('/payment-tokens')
  },
  createPaymentToken: (data) => {
    return Ajax.post('/payment-tokens', { data })
  },
  deletePaymentToken: (id) => {
    return Ajax.delete(`/payment-tokens/${id}`)
  },
  getSellerWhitelist: () => {
    return Ajax.get('/seller-whitelists')
  },
  addToWhitelist: (wallet, label) => {
    return Ajax.post('/seller-whitelists', { data: { wallet, label } })
  },
  removeFromWhitelist: (id) => {
    return Ajax.delete(`/seller-whitelists/${id}`)
  }
}

export default PaymentToken
